import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }

import { Form } from 'vee-validate';
import { ref } from 'vue';
import { type Picture } from '@/types/photo-uploader';
import { messageSend } from '@/js/lib/api/message';
import { credentials } from '@/js/lib/api/user';
import { useUserStore } from '@/js/lib/store/user';
import { confirm, info, loading } from '@/js/lib/ui';
import { signinSignup } from '@/js/lib/ui/signin-signup';
import PhotoUploader from '@/js/components/common/ui/form/photo-uploader.vue';
import IButton from '@/js/components/molecules/IButton.vue';
import IMenu from '@/js/components/molecules/IMenu.vue';
import IModal from '@/js/components/molecules/IModal.vue';
import ITextArea from '@/js/components/molecules/ITextArea.vue';
import ITextField from '@/js/components/molecules/ITextField.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageButton',
  props: {
    disabled: { type: Boolean },
    itemId: { default: 0 },
    shopId: {},
    subject: { default: '' }
  },
  setup(__props: any) {

const props = __props;
const userStore = useUserStore();
const isShowImage = ref(false);
const isShowMessageDialog = ref(false);
const subjectStr = ref(props.subject);
const messageStr = ref(props.itemId ? `\n\n${window.location.href.replace(window.location.search, '').replace(window.location.hash, '')}` : '');
const pictures = ref<Picture[]>([]);
const onClick = () => {
  if (userStore.isAuthenticated) {
    if (userStore.hasCredential(credentials.emailConfirmed)) {
      isShowMessageDialog.value = true;
    } else {
      info('メッセージを送信するにはメール認証が必要です。\n「マイページ > 設定 > ログイン情報 > メールアドレスの変更」よりメール認証を行ってください。');
    }
  } else {
    signinSignup({
      next: window.location.href,
      callback: () => {
        window.location.reload();
      },
    });
  }
};
const onSubmit = async () => {
  if (await confirm('メッセージを送信します。\nよろしいですか？')) {
    loading({
      asyncFunc: async () => {
        await messageSend({
          shopId: props.shopId,
          itemId: props.itemId,
          picture: pictures.value[0],
          subject: subjectStr.value,
          message: messageStr.value,
        });
        await info('メッセージを送信しました', { fadeOut: true });
        window.location.reload();
      },
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.itemId)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          disabled: _ctx.disabled,
          class: _normalizeClass(_ctx.$style.itemButton),
          onClick: onClick
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("span", null, "質問", -1)
        ]), 10, _hoisted_1))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          disabled: _ctx.disabled,
          title: "メッセージを送る",
          class: _normalizeClass(_ctx.$style.shopButton),
          onClick: onClick
        }, null, 10, _hoisted_2)),
    _cache[18] || (_cache[18] = _createTextVNode()),
    _createVNode(IModal, {
      modelValue: isShowMessageDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isShowMessageDialog).value = $event)),
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.$style.title)
        }, "メッセージを送る", 2),
        _cache[17] || (_cache[17] = _createTextVNode()),
        _createVNode(_unref(Form), {
          class: _normalizeClass(_ctx.$style.form),
          onSubmit: onSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("section", null, [
              _createVNode(ITextField, {
                modelValue: subjectStr.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subjectStr).value = $event)),
                name: "件名",
                title: "件名",
                rules: "required|max:200"
              }, null, 8, ["modelValue"])
            ]),
            _cache[13] || (_cache[13] = _createTextVNode()),
            _createElementVNode("section", null, [
              _createVNode(ITextArea, {
                modelValue: messageStr.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((messageStr).value = $event)),
                name: "メッセージ",
                title: "メッセージ",
                rows: 5,
                rules: "required|max:800"
              }, null, 8, ["modelValue"])
            ]),
            _cache[14] || (_cache[14] = _createTextVNode()),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.attach)
            }, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (isShowImage.value = !isShowImage.value), ["prevent"]))
              }, "画像を添付する")
            ], 2),
            _cache[15] || (_cache[15] = _createTextVNode()),
            (isShowImage.value)
              ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.sectionHeader)
                  }, [
                    _cache[9] || (_cache[9] = _createElementVNode("p", null, "添付画像(任意)", -1)),
                    _cache[10] || (_cache[10] = _createTextVNode()),
                    _createVNode(IMenu, { width: "276" }, {
                      link: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "icon-question-circle" }, null, -1)
                      ])),
                      menu: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("\n                [推奨画像サイズ] 横320ピクセル以上", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("\n                [対応フォーマット] GIF、JPEG、PNG", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("\n                [ファイルサイズ] 10MB以下\n              ", -1)
                      ])),
                      _: 1,
                      __: [8]
                    })
                  ], 2),
                  _cache[11] || (_cache[11] = _createTextVNode()),
                  _createVNode(PhotoUploader, {
                    modelValue: pictures.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((pictures).value = $event)),
                    name: "添付画像"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _cache[16] || (_cache[16] = _createTextVNode()),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.send)
            }, [
              _createVNode(IButton, {
                type: "primary",
                "native-type": "submit"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("送信する", -1)
                ])),
                _: 1,
                __: [12]
              })
            ], 2)
          ]),
          _: 1,
          __: [13,14,15,16]
        }, 8, ["class"])
      ]),
      _: 1,
      __: [17]
    }, 8, ["modelValue"])
  ]))
}
}

})